import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Layout } from 'antd';
import { Debounce } from 'react-throttle';
import WindowResizeListener from 'react-window-size-listener';
import { ThemeProvider } from 'styled-components';
import authAction from '../../redux/auth/actions';
import appActions from '../../redux/app/actions';
import Sidebar from '../Sidebar/Sidebar';
import Topbar from '../Topbar/Topbar';
import AppRouter from './AppRouter';
import { siteConfig, themeConfig } from '../../config.js';
import themes from '../../config/themes';

import AppHolder from './commonStyle';
import { getToken } from '../../helpers/utility';
import WelcomeModal from '../../components/welcomeModal';
import { getEnterprisePlan } from '../../helpers/helper';

const { Content, Footer } = Layout;
const { logout, resetFirstTimeLogin } = authAction;
const { toggleAll } = appActions;

export class App extends Component {
  constructor(props) {
    super(props);
  }

  async componentWillMount() {
    getToken();
    await getEnterprisePlan();
    window.addEventListener('beforeunload', () => {
      localStorage.setItem('selectedUser', '');
    });
  }

  render() {
    const { url } = this.props.match;
    const { hasPremium } = this.props;
    return (
      <ThemeProvider theme={themes[themeConfig.theme]}>
        <AppHolder>
          <Layout style={{ height: '100vh', boxShadow: '0 2px 6px 0 rgba(116,135,162,0.175)' }}>
            <Debounce time='1000' handler='onResize'>
              <WindowResizeListener
                onResize={windowSize =>
                  this.props.toggleAll(windowSize.windowWidth, windowSize.windowHeight)
                }
              />
            </Debounce>
            <Layout style={{ flexDirection: 'row', overflowX: 'hidden' }}>
              <Sidebar url={url} />
              <Layout
                className='isoContentMainLayout bt_portal-layout'
                style={{
                  height: '100vh',
                }}
              >
                <Topbar url={url} />
                <Content className='isomorphicContent bt_portal-main_content'>
                  <AppRouter url={url} hasPremium={hasPremium} />
                </Content>
                <Footer
                  style={{
                    background: 'transparent',
                    textAlign: 'center',
                    borderTop: '1px solid #ededed',
                  }}
                >
                  {siteConfig.footerText}
                </Footer>
              </Layout>
            </Layout>
            <WelcomeModal />
          </Layout>
        </AppHolder>
      </ThemeProvider>
    );
  }
}

export default connect(
  state => ({
    auth: state.Auth,
  }),
  { logout, toggleAll, resetFirstTimeLogin },
)(App);
